import React, { useState } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import ConfirmModal from '../components/ConfirmModal';
import BatchToggleForceBypassBridge from './adminBridge/batchToggleForceBypassBridge';
import { Mutation, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { useEffect } from 'react';
import { isToggleActive, isToggleExists, ToggleValues } from '../components/featureToggle/toggles';
import { ADD_FEATURE_TOGGLE, GET_FEATURE_TOGGLES_LIST, UPDATE_FEATURE_TOGGLE } from '../graphql';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 48px 6px 0 6px;
`;
const ModalInner = styled(Box)`
  max-width: 80vw;
  min-width: 80vw;
  width: 100%;
  max-height: 700px;
  overflow-y: auto;
`;
const REPORT_BRIDGE_USERS = gql`
  mutation getUsersWithBridgeId {
    getUsersWithBridgeId {
      ok
    }
  }
`;
const REPORT_FORCE_LEGACY = gql`
  mutation getUsersWithForceBypassBridge {
    getUsersWithForceBypassBridge {
      ok
    }
  }
`;

const TOGGLE_BRIDGE = 'BRIDGE';

const AdminBridge = ({ client }) => {
  const [batchToggle, setBatchToggle] = useState(false);
  const [toggleActive, setToggleActive] = useState(isToggleActive(TOGGLE_BRIDGE));
  const [toggleExists, setToggleExists] = useState(isToggleExists(TOGGLE_BRIDGE));

  const refresh = async () => {
    const res = await client.query({
      query: GET_FEATURE_TOGGLES_LIST,
    });
    if (res && res.data && res.data.getFeatureTogglesList) {
      ToggleValues.list = res.data.getFeatureTogglesList;
    } else {
    }
    const isActive = isToggleActive(TOGGLE_BRIDGE);
    setToggleActive(isActive);
    setToggleExists(isToggleExists(TOGGLE_BRIDGE));
  };

  return (
    <Container>
      <Flex mb={4}>
        <Heading flex={1}>BRIDGE USERS MANAGEMENT</Heading>
        {!toggleExists ? (
          <Mutation mutation={ADD_FEATURE_TOGGLE} refetchQueries={[{ query: GET_FEATURE_TOGGLES_LIST }]}>
            {(mutate, { loading }) => (
              <Button
                disabled={!!loading}
                onClick={() => {
                  mutate({
                    variables: {
                      friendlyName: TOGGLE_BRIDGE,
                      name: TOGGLE_BRIDGE,
                      isActive: true,
                    },
                  });
                }}
                variant={'primary'}
              >
                Add Feature Toggle Bridge
              </Button>
            )}
          </Mutation>
        ) : (
          <Mutation
            mutation={UPDATE_FEATURE_TOGGLE}
            refetchQueries={[{ query: GET_FEATURE_TOGGLES_LIST }]}
            onCompleted={() => {
              refresh();
            }}
          >
            {(mutate, { loading }) => (
              <>
                {toggleActive ? (
                  <Button
                    disabled={!!loading}
                    variant={'pink'}
                    onClick={() => {
                      mutate({
                        variables: {
                          friendlyName: TOGGLE_BRIDGE,
                          name: TOGGLE_BRIDGE,
                          isActive: false,
                        },
                      });
                    }}
                  >
                    Turn off Bridge
                  </Button>
                ) : (
                  <Button
                    disabled={!!loading}
                    variant={'primary'}
                    onClick={() => {
                      mutate({
                        variables: {
                          friendlyName: TOGGLE_BRIDGE,
                          name: TOGGLE_BRIDGE,
                          isActive: true,
                        },
                      });
                    }}
                  >
                    Turn on Bridge
                  </Button>
                )}
              </>
            )}
          </Mutation>
        )}
      </Flex>
      <Text mb={2}>Get list of users with Bridge ID</Text>
      <Mutation mutation={REPORT_BRIDGE_USERS}>
        {(mutate, { loading }) => {
          return (
            <Button onClick={mutate} variant={'primary'} disabled={!!loading}>
              {!!loading ? 'Generating...' : 'Send report via email'}
            </Button>
          );
        }}
      </Mutation>
      <Text mb={2} mt={4}>
        Get list of users forced to use legacy scheduling (bypass Bridge)
      </Text>
      <Mutation mutation={REPORT_FORCE_LEGACY}>
        {(mutate, { loading }) => {
          return (
            <Button onClick={mutate} variant={'primary'} disabled={!!loading}>
              {!!loading ? 'Generating...' : 'Send report via email'}
            </Button>
          );
        }}
      </Mutation>
      <Text mb={2} mt={4}>
        Batch toggle force legacy scheduling
      </Text>
      <Button variant={'primary'} onClick={() => setBatchToggle(true)}>
        Start
      </Button>

      {!!batchToggle && (
        <ConfirmModal isOpen={batchToggle} onClose={() => setBatchToggle(false)} onBackgroundClick={() => setBatchToggle(false)} onConfirm={() => setBatchToggle(false)} okOnly displayX>
          <ModalInner>
            <BatchToggleForceBypassBridge />
          </ModalInner>
        </ConfirmModal>
      )}
    </Container>
  );
};

export default withApollo(AdminBridge);
